<template>

    <v-notice v-if="error" :title="title" :message="error" />

</template>

<script>

export default {

    props: {
        title: {
            type: String,
            default: 'Unable to Load Page',
        },
        error: {
            type: String,
        },
    },

}

</script>
